import { createFileRoute } from '@tanstack/react-router'
import { loaderScope, travelQuery } from '~/features/operations/queries'
import { Gate, RouteError } from '~/features/operations/shared'
import { mayRead } from '~/features/org/guard'
import { TravelPage } from '~/features/operations/TravelPage'

export const Route = createFileRoute('/_app/verein/fahrtkosten/')({
  loader: async ({ context }) => {
    if (!(await mayRead(context.queryClient, 'finance.read'))) return
    const { teamId, season } = await loaderScope(context.queryClient)
    if (teamId) await context.queryClient.ensureQueryData(travelQuery(teamId, season))
  },
  component: () => (
    <Gate permission="finance.read">
      <TravelPage />
    </Gate>
  ),
  errorComponent: RouteError,
})
